// src/context/AuthContext.js

import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../api/api';

const AuthContext = createContext();

// Utilidad para limpiar y redirigir
export function doLogout() {
  localStorage.removeItem('adminAuth');
  window.location.href = '/login';
}

export const AuthProvider = ({ children }) => {
  // adminAuth guarda el { token, user } final
  const [adminAuth, setAdminAuth] = useState(() => {
    const stored = localStorage.getItem('adminAuth');
    return stored ? JSON.parse(stored) : null;
  });

  // tempToken que viene tras /auth/login y antes del OTP
  const [tempToken, setTempToken] = useState(null);
  // pending indica que hay que pedir OTP
  const pending = Boolean(tempToken && !adminAuth);

  // Guarda el JWT y el user definitivo
  const login = (data) => {
    localStorage.setItem('adminAuth', JSON.stringify(data));
    setAdminAuth(data);
    setTempToken(null);
  };

  // Limpia todo y redirige
  const logout = () => {
    doLogout();
    setAdminAuth(null);
    setTempToken(null);
  };

  // Paso 1: usuario+clave → tempToken
  const initiateLogin = async ({ username, password }) => {
    const { data } = await api.post('/auth/login', { username, password });
    setTempToken(data.tempToken);
  };

  // Paso 2: otp → JWT final
  const verifyOtp = async (otp) => {
    if (!tempToken) {
      throw new Error('No hay sesión pendiente de OTP');
    }
    const { data } = await api.post('/auth/verify-otp', {
      tempToken,
      otp,
    });
    login(data);
  };

  // On mount, recupera adminAuth si existe
  useEffect(() => {
    const stored = localStorage.getItem('adminAuth');
    if (stored && !adminAuth) {
      setAdminAuth(JSON.parse(stored));
    }
  }, [adminAuth]);

  return (
    <AuthContext.Provider
      value={{
        adminAuth,   // { token, user }
        pending,     // true tras initiateLogin hasta verifyOtp
        login,
        logout,
        initiateLogin,
        verifyOtp,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
